module.exports = __webpack_public_path__ + "static/media/value-poster-7.52396c27.png";